import { ArrowLeftOutlined, PhoneFilled } from '@ant-design/icons';
import { Avatar, Button, Dropdown, MenuProps } from 'antd';
import { useMemo } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import ModalCatcher from 'components/modals/ModalCatcher';
import { useUser } from 'stores/user/userHooks';
import Footer from 'commons/components/footer/Footer';
import LogoLight from 'commons/assets/LogoLight';
import HubspotChat from 'components/hubspotchat/HubspotChat';
import Logo from 'commons/assets/Logo';

export default function MainLayout() {
  const { pathname } = useLocation();
  const header =
    pathname !== '/' ? <BackHeader pathname={pathname} /> : <NormalHeader />;
  return (
    <div className='flex flex-col min-h-screen'>
      <ModalCatcher />
      {header}
      <main className='flex flex-col px-2 grow mx-auto w-full max-w-screen-lg'>
        <Outlet />
      </main>
      <Footer />
      <HubspotChat />
    </div>
  );
}

function BackHeader({ pathname }: { pathname: string }) {
  const title = useMemo(() => {
    switch (pathname) {
      case '/schedule':
        return 'Planifier mon rendez-vous';
      case '/payment':
        return 'Payer mon rendez-vous';
      case '/cancelled':
        return 'Déplacer mon rendez-vous';
      case '/profile':
        return 'Mon compte';
      case '/documents':
        return 'Mes documents';
      case '/past-schedules':
        return 'Mes rendez-vous passées';
      case '/move-schedule':
        return 'Déplacer mon rendez-vous';
      default:
        return '';
    }
  }, [pathname]);

  // First scheduling have custom header
  if (
    pathname === '/schedule/rdv_1' ||
    pathname === '/schedule/rdv_2' ||
    pathname === '/schedule/rdv_switch'
  ) {
    return (
      <header className='flex relative items-center justify-between h-24 shadow-md mb-4'>
        <div className='ml-4'>
          <a href='https://hapni.fr'>
            <Logo width={80} />
          </a>
        </div>
        <a href='tel:+33978450287'>
          <Button
            type='default'
            className='!bg-secondary !text-white !h-12 !rounded-3xl mr-4 !text-lg !font-semibold'
            icon={<PhoneFilled className='text-2xl transform -scale-x-100' />}
          >
            09 78 45 02 87
          </Button>
        </a>
      </header>
    );
  }

  return (
    <header className='flex relative items-center justify-between h-16'>
      <Link
        to='/'
        className='ml-4'
      >
        <ArrowLeftOutlined />
      </Link>
      <p className='m-0 text-sm font-semibold'>{title}</p>
      <div className='mr-4'>
        <a href='https://hapni.fr'>
          <LogoLight width={80} />
        </a>
      </div>
    </header>
  );
}
function NormalHeader() {
  const [user] = useUser();

  const menuProps: MenuProps = useMemo(
    () => ({
      items: [],
    }),
    [],
  );

  return (
    <header className='flex items-center justify-between h-16'>
      <div className='flex items-center justify-start'>
        <div className='px-3'>
          {user && (
            <Dropdown menu={menuProps}>
              <Avatar>
                {`${user?.firstName?.charAt(0) || ''}${
                  user?.lastName?.charAt(0) || ''
                }`}
              </Avatar>
            </Dropdown>
          )}
        </div>
        <div>
          <p className='m-0 text-sm font-semibold'>
            Bonjour, {user?.firstName} {user?.lastName}
          </p>
          <Link
            to='/profile'
            className='m-0 text-xs text-primary'
          >
            Mon compte
          </Link>
        </div>
      </div>
      <div className='mr-4'>
        <a href='https://hapni.fr'>
          <LogoLight width={80} />
        </a>
      </div>
    </header>
  );
}
